import { jsxs, jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmUpload = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-upload",
    "data-icon": "icon-llm-upload",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: [jsxs("g", {
      clipPath: "url(#clip0_469_4822)",
      children: [jsx("path", {
        d: "M3.75 12H20.25",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), jsx("path", {
        d: "M12 3.75V20.25",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_469_4822",
        children: jsx("rect", {
          width: "24",
          height: "24",
          fill: "currentColor"
        })
      })
    })]
  }));
});
IconLlmUpload.displayName = 'IconLlmUpload';

export { IconLlmUpload };
//# sourceMappingURL=llm-upload.js.map
